var map = {
	"./Combined Shape.svg": [
		5108,
		5108
	],
	"./add.svg": [
		8371,
		8371
	],
	"./addPerson.svg": [
		6716,
		6716
	],
	"./alert.svg": [
		192,
		192
	],
	"./archive.svg": [
		7752,
		5371
	],
	"./arrow-right.svg": [
		6876,
		6876
	],
	"./bank.svg": [
		6500,
		6500
	],
	"./bankid.svg": [
		4307,
		4307
	],
	"./barista.svg": [
		8312,
		8312
	],
	"./bartender.svg": [
		87,
		87
	],
	"./bell.svg": [
		333,
		333
	],
	"./calendar.svg": [
		3300,
		3300
	],
	"./camera.svg": [
		6827,
		6827
	],
	"./card.svg": [
		5371,
		7752
	],
	"./cashier.svg": [
		4433,
		4433
	],
	"./chat.svg": [
		1244,
		1244
	],
	"./checkmark.svg": [
		1033,
		1033
	],
	"./chef.svg": [
		2586,
		2586
	],
	"./chevron-down.svg": [
		2764,
		2764
	],
	"./chevron-left.svg": [
		5211,
		5211
	],
	"./chevron-right.svg": [
		734,
		734
	],
	"./chevron-up.svg": [
		135,
		135
	],
	"./clock.svg": [
		5980,
		5980
	],
	"./clone.svg": [
		4546,
		2165
	],
	"./company.svg": [
		3779,
		3779
	],
	"./cross.svg": [
		7102,
		7102
	],
	"./day.svg": [
		9920,
		9920
	],
	"./dishwasher.svg": [
		5702,
		5702
	],
	"./document.svg": [
		6077,
		6077
	],
	"./doorman.svg": [
		8670,
		8670
	],
	"./download.svg": [
		8782,
		8782
	],
	"./downward_arrow.svg": [
		3806,
		3806
	],
	"./duplicate.svg": [
		5697,
		5697
	],
	"./eye.svg": [
		7057,
		7057
	],
	"./favorites-active.svg": [
		4792,
		4792
	],
	"./favorites-inactive.svg": [
		6753,
		6753
	],
	"./filter.svg": [
		7148,
		7148
	],
	"./group.svg": [
		9535,
		9535
	],
	"./hamburger.svg": [
		3183,
		3183
	],
	"./home-cleaning.svg": [
		517,
		517
	],
	"./hotel-cleaning.svg": [
		7496,
		7496
	],
	"./idbadge.svg": [
		7466,
		7466
	],
	"./image.svg": [
		741,
		741
	],
	"./kitchen.svg": [
		3398,
		3398
	],
	"./letter.svg": [
		4186,
		4186
	],
	"./list.svg": [
		1530,
		1530
	],
	"./lock.svg": [
		1287,
		1287
	],
	"./logout.svg": [
		8908,
		8908
	],
	"./mail.svg": [
		4827,
		4827
	],
	"./message.svg": [
		3379,
		3379
	],
	"./minus.svg": [
		8026,
		8026
	],
	"./minus_old.svg": [
		1156,
		1156
	],
	"./overflow.svg": [
		4104,
		4104
	],
	"./paginationArrowLeft.svg": [
		2098,
		2098
	],
	"./paginationArrowRight.svg": [
		441,
		441
	],
	"./pen.svg": [
		3999,
		3999
	],
	"./person.svg": [
		3325,
		3325
	],
	"./phone.svg": [
		3998,
		3998
	],
	"./pin.svg": [
		6099,
		6099
	],
	"./play.svg": [
		4668,
		4668
	],
	"./plus.svg": [
		8546,
		8546
	],
	"./plus_old.svg": [
		5948,
		5948
	],
	"./preparation.svg": [
		2773,
		2773
	],
	"./question.svg": [
		1238,
		1238
	],
	"./receipt.svg": [
		7222,
		7222
	],
	"./receptionist.svg": [
		979,
		979
	],
	"./reload.svg": [
		4261,
		4261
	],
	"./search.svg": [
		7622,
		7622
	],
	"./security-guard.svg": [
		9616,
		9616
	],
	"./settings.svg": [
		7733,
		7733
	],
	"./share.svg": [
		8051,
		8051
	],
	"./star-filled.svg": [
		3859,
		3859
	],
	"./star.svg": [
		1817,
		4198
	],
	"./trashcan.svg": [
		3126,
		3126
	],
	"./upward_arrow.svg": [
		6697,
		6697
	],
	"./user-minus.svg": [
		6016,
		6016
	],
	"./v2/absent.svg": [
		6482,
		6482
	],
	"./v2/bank.svg": [
		9684,
		7303
	],
	"./v2/calendar.svg": [
		6525,
		3668
	],
	"./v2/chart.svg": [
		5923,
		5923
	],
	"./v2/chat.svg": [
		1131,
		1131
	],
	"./v2/checkmark.svg": [
		3652,
		3652
	],
	"./v2/clock.svg": [
		617,
		617
	],
	"./v2/cross-person.svg": [
		4015,
		4015
	],
	"./v2/cross.svg": [
		1831,
		1831
	],
	"./v2/document.svg": [
		7030,
		7030
	],
	"./v2/dollar_circle.svg": [
		4726,
		4726
	],
	"./v2/down-chevron.svg": [
		5479,
		5479
	],
	"./v2/download.svg": [
		857,
		857
	],
	"./v2/envelope.svg": [
		6801,
		6801
	],
	"./v2/expand-vertical.svg": [
		3612,
		3612
	],
	"./v2/eye.svg": [
		7072,
		7072
	],
	"./v2/globe.svg": [
		8863,
		8863
	],
	"./v2/info.svg": [
		3817,
		3817
	],
	"./v2/left-arrow.svg": [
		4278,
		4278
	],
	"./v2/left-chevron.svg": [
		452,
		452
	],
	"./v2/list.svg": [
		3045,
		3045
	],
	"./v2/logout.svg": [
		8571,
		8571
	],
	"./v2/menu.svg": [
		3216,
		3216
	],
	"./v2/minus-person.svg": [
		951,
		951
	],
	"./v2/money.svg": [
		2127,
		2127
	],
	"./v2/monochrome-simflexity.svg": [
		7271,
		7271
	],
	"./v2/not-visible.svg": [
		7545,
		7545
	],
	"./v2/pen.svg": [
		5742,
		5742
	],
	"./v2/percent.svg": [
		5252,
		5252
	],
	"./v2/person.svg": [
		9758,
		9758
	],
	"./v2/picture.svg": [
		2629,
		2629
	],
	"./v2/plus-person.svg": [
		3093,
		3093
	],
	"./v2/plus.svg": [
		8833,
		8833
	],
	"./v2/reload.svg": [
		4594,
		4594
	],
	"./v2/reset.svg": [
		9978,
		9978
	],
	"./v2/right-arrow.svg": [
		7821,
		7821
	],
	"./v2/right-chevron.svg": [
		983,
		983
	],
	"./v2/roster.svg": [
		6052,
		6052
	],
	"./v2/search.svg": [
		1645,
		1645
	],
	"./v2/send.svg": [
		2963,
		2963
	],
	"./v2/settings.svg": [
		1710,
		1710
	],
	"./v2/shift.svg": [
		2047,
		2047
	],
	"./v2/simflexity-logo.svg": [
		5760,
		5760
	],
	"./v2/simflexity.svg": [
		9053,
		9053
	],
	"./v2/small-checkmark.svg": [
		3802,
		3802
	],
	"./v2/star.svg": [
		3761,
		3761
	],
	"./v2/swish.svg": [
		1345,
		1345
	],
	"./v2/team.svg": [
		3434,
		3434
	],
	"./v2/transfer.svg": [
		3236,
		3236
	],
	"./v2/trash.svg": [
		2073,
		2073
	],
	"./v2/unreported.svg": [
		3577,
		3577
	],
	"./v2/up-chevron.svg": [
		1904,
		1904
	],
	"./v2/wallet.svg": [
		2336,
		7574
	],
	"./v2/warning-triangle.svg": [
		2504,
		2504
	],
	"./v2/white-simflexity.svg": [
		2365,
		2365
	],
	"./video.svg": [
		371,
		371
	],
	"./wallet.svg": [
		4457,
		4457
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5744;
module.exports = webpackAsyncContext;